<template>
    <div class="MentoringInfo container relative flex flex-col pb-8 lg:flex-row" :class="colorBG">
        <div class="flex flex-col lg:max-w-xl">
            <h2 class="mb-4 text-left text-2xl font-black text-black dark:text-white lg:text-4xl lg:leading-[46.8px]">
                <slot name="title" />
            </h2>
            <CText variant="muted">
                <slot name="message" />
            </CText>

            <slot name="body-left" />
        </div>

        <slot name="body-right" />
    </div>
</template>

<script setup lang="ts">
import CText from '@/components/ui/CText.vue'

defineProps({
    colorBG: {
        type: String,
        default: 'bg-white dark:bg-surface-card'
    }
})
</script>
